import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { TnIconComponent } from '@truenas/ui-components';
import { TypedApiService } from 'app/modules/websocket/typed-api/typed-api.service';

@Component({
  selector: 'ix-true-command-status',
  templateUrl: './true-command-status.component.html',
  styleUrls: ['./true-command-status.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    TranslateModule,
    AsyncPipe,
    TnIconComponent,
  ],
})
export class TrueCommandStatusComponent {
  private api = inject(TypedApiService);

  protected isManagedByTruecommand$ = this.api.callUnauthenticated('truenas.managed_by_truecommand');
}
